import { render, staticRenderFns } from "./ERC721.vue?vue&type=template&id=5b6b84c1&"
import script from "./ERC721.vue?vue&type=script&lang=js&"
export * from "./ERC721.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports